import { CartItems } from "../Interface/Order.interface";

export const createCartPayload = (
    mid: number,
    selectedProduct: any,
    quantity: number,
    totalPrice:number,
    discountValue:number,
    totalAmount:number,
    netTotal:number,


): CartItems[] => {

    return [
        {
            
            cartId: 0, // Always default to 0 for new cart items
            memberId: mid,
            productId: selectedProduct?.itemid || 0,
            productQty: quantity,
            webName: '',
            barcode: selectedProduct?.Barcode || '',
            batchno: selectedProduct?.batchno || '',
            sellingrate:totalPrice,
            mrprate:selectedProduct.Mrprate,
            netAmount:netTotal,
            discountamount:discountValue,
            totalAmount:totalAmount

        }
    ];
};
